// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Segments_tabsContainer__w7UKc","tab":"Segments_tab__2-V2G","tabActive":"Segments_tabActive__3hChT","userCounter":"Segments_userCounter__q6g2E"};